<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Wallets List">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-between pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-select
                  *appHasPlatformAccess
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
                <app-input-select
                  *ngIf="!isSuperAdmin"
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.sender"
                  [selectOptions]="senderList"
                  [bindLabel]="'sender_name'"
                  [bindValue]="'sender_id'"
                  [formControlName]="
                    attrConstant.sender.key
                  "></app-input-select>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
              <div class="d-flex align-items-center gap-10">
                <img
                  src="assets/images/reload.svg"
                  alt="reload"
                  class="reload-img"
                  matTooltip="Reload"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="reload()" />
                <button class="btn primary-btn" (click)="export()">
                  Export
                </button>
              </div>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Partner Name Column -->
              <ng-container matColumnDef="partner_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Partner Name
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Partner Name">
                  {{ element.partner_name ?? '--' }}
                </td>
              </ng-container>

              <!-- Sender Name Column -->
              <ng-container matColumnDef="sender_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Sender Name
                </th>
                <td mat-cell *matCellDef="let element" data-label="Sender Name">
                  {{ element.sender_name ?? '--' }}
                </td>
              </ng-container>

              <!-- Country Column -->
              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Country
                </th>
                <td mat-cell *matCellDef="let element" data-label="Country">
                  {{ element.country }}
                </td>
              </ng-container>

              <!-- Currency Column -->
              <ng-container matColumnDef="currency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Currency
                </th>
                <td mat-cell *matCellDef="let element" data-label="Currency">
                  {{ element.currency }}
                </td>
              </ng-container>

              <!-- Balance Column -->
              <ng-container matColumnDef="balance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Balance
                </th>
                <td mat-cell *matCellDef="let element" data-label="Balance">
                  {{ element.balance }}
                </td>
              </ng-container>

              <!-- Created Date Column -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Created Date
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Created Date">
                  {{ element.created_at | date: 'dd/MM/yyyy' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="
                  let row;
                  columns: displayedColumns;
                  let element
                "></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)"></mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'add-wallet'">
        <ng-template mat-tab-label>
          <a
            (click)="addWallet()"
            class="btn primary-btn"
            [attr.aria-hidden]="true">
            Add Wallet
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
